import React from 'react';
import { useSiteFeatureFlags } from '../../hooks/useSiteFeatureFlags';
import TransferSiteFooter from './TransferSiteFooter';
import TransferSiteHeader from './TransferSiteHeader';

/**
 * The legal pages (terms, privacy, accessibility) are standalone dark pages with no
 * header or footer of their own. In the Transfer Site template they get the same menu
 * bar and slim footer as every other page; with the template off this is a pass-through
 * and the pages are exactly as they were.
 */
const TemplateFrame = ({ children }) => {
  const { transfer_site_enabled } = useSiteFeatureFlags();
  if (!transfer_site_enabled) return children;
  return (
    <div className="min-h-screen flex flex-col bg-slate-950">
      <TransferSiteHeader dark />
      <div className="flex-1">{children}</div>
      <TransferSiteFooter dark />
    </div>
  );
};

export default TemplateFrame;
